import { render, staticRenderFns } from "./studentTcfForm.vue?vue&type=template&id=71443316&scoped=true&"
import script from "./studentTcfForm.vue?vue&type=script&lang=js&"
export * from "./studentTcfForm.vue?vue&type=script&lang=js&"
import style0 from "./studentTcfForm.vue?vue&type=style&index=0&id=71443316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71443316",
  null
  
)

export default component.exports